<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      v-if="!print"
      class="accordion-header collapsed"
    >
      <button
        class="accordion-button"
        :class="{ collapsed: !isOpen }"
        :aria-expanded="isOpen"
        @click="isOpen = !isOpen"
        v-html="title"
      />
    </div>

    <div
      class="accordion-collapse collapse"
      :class="{ show: isOpen || print }"
      aria-labelledby="panelsStayOpen-headingOne"
    >
      <div class="accordion-body p-3">
        <div>
          <div class="form-group ps-1 border-primary">
            <div class="mb-4">
              <!-- foreach question -->
              <QuestionForm
                :underwriting-questions="underwritingQuestions"
                :prefix="prefix"
                :print="print"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionForm from './QuestionForm.vue'

export default {
  name: 'UnderwritingQuestionForm',
  components: {
    QuestionForm,
  },
  props: {
    underwritingQuestions: { type: Array, required: true },
    prefix: {
      type: String,
      required: true,
    },
    title: { type: String, required: true },
    isCollapse: {
      type: Boolean,
      require: true,
    },
    print: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    isCollapse() {
      this.isOpen = this.$isCollapse
    },
  },
  mounted() {},
  methods: {},
}
</script>
